import Box from 'components_new/atoms/Box'
import React from 'react'
import {
  CustomPeriodFilter,
  isCoreWidgetFullyLoaded,
  PeriodFilter,
  TCoreWidget,
  WidgetType
} from 'types/GlobalWidget'
import DateFilterSection from './DateFilterSection'

interface WidgetFooterProps {
  customPeriodFilter: CustomPeriodFilter | null
  embedded: boolean
  interactive: boolean
  periodFilter: PeriodFilter | null
  scaleFactor: number
  widget: TCoreWidget
}

const WidgetFooter = (props: WidgetFooterProps) => {
  const {
    customPeriodFilter,
    embedded,
    interactive,
    periodFilter,
    scaleFactor,
    widget
  } = props

  const showFooter =
    widget.type !== WidgetType.COMMENT && widget.type !== WidgetType.IMAGE

  return showFooter && isCoreWidgetFullyLoaded(widget) ? (
    <Box
      sx={{
        mt: scaleFactor,
        position: 'relative'
      }}
    >
      <DateFilterSection
        dashboardCustomPeriodFilter={customPeriodFilter}
        dashboardPeriodFilter={periodFilter}
        embedded={embedded}
        interactive={interactive}
        scaleFactor={scaleFactor}
        widget={widget}
      />
    </Box>
  ) : null
}

export default WidgetFooter
